<template>
  <div>
    <LoaderMaskComponent v-if="lyLoading" />
    <div v-else>
      <div class="d_flex_btwn">
        <h1 class="common_title">
          <span v-if="$route.params.id">Edit Ticket</span> 
          <span v-else>Create a New Ticket</span>
        </h1>
        <span>
          <router-link :to="{name: 'tickets'}" class="btn btn_black">Back to List</router-link>
        </span>
      </div>
      <div class="card border_none">
        <div class="card_body pl_0 pr_0">
          <div class="row">
            <div class="col_6 pr_20">
              <div class="row">
                <div class="col_6">
                  <div v-if="user?.user_role === 'Admin'" :class="['form_row', {'has_error': errorFor('group_id')}]">
                    <label class="required">Group</label>
                      <Multiselect
                        v-model="selectedGroup"
                        :options="groups"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Select a group"
                        label="name"
                        track-by="id"
                        :optionHeight="20"
                        @Select="onGroupSelect"
                        @remove="onGroupRemove"
                      />
                      <v-errors :errors="errorFor('group_id')"></v-errors>
                  </div>
                  <div v-if="user?.user_role === 'Admin'" :class="['form_row', {'has_error': errorFor('support_request_type_id')}]">
                    <label class="required">Request Type</label>
                      <Multiselect
                        v-model="selectedRequestType"
                        :options="requestTypes"
                        :multiple="false"
                        :close-on-select="true"
                        placeholder="Select a request type"
                        label="name"
                        track-by="id"
                        :optionHeight="20"
                        @Select="onRequestTypeSelect"
                        @remove="onRequestTypeRemove"
                      />
                      <v-errors :errors="errorFor('support_request_type_id')"></v-errors>
                  </div>
                  <div :class="['form_row', {'has_error': errorFor('status')}]">
                    <label class="required">Status</label>
                      <Multiselect
                        v-model="selectedStatus"
                        :options="statuses"
                        :multiple="false"
                        :close-on-select="true"
                        :optionHeight="20"
                        placeholder="Select a status"
                        label="name"
                        track-by="label"
                        @Select="onStatusSelect"
                        @remove="onStatusRemove"
                      />
                      <v-errors :errors="errorFor('status')"></v-errors>
                  </div>
                </div>
                <div class="col_6">
                  <div v-if="user?.user_role === 'Admin'" :class="['form_row', {'has_error': errorFor('user_id')}]">
                    <label class="required">User</label>
                      <Multiselect
                        v-model="selectedUser"
                        :options="users"
                        :multiple="false"
                        :optionHeight="20"
                        :close-on-select="true"
                        placeholder="Select a user"
                        label="name"
                        track-by="id"
                        @Select="onUserSelect"
                        @remove="onUserRemove"
                      />
                      <v-errors :errors="errorFor('user_id')"></v-errors>
                  </div>
                  <div :class="['form_row', {'has_error': errorFor('priority')}]">
                    <label class="required">Priority</label>
                      <Multiselect
                        v-model="selectedPriority"
                        :options="priorities"
                        :multiple="false"
                        :optionHeight="20"
                        :close-on-select="true"
                        placeholder="Select a priority"
                        label="name"
                        track-by="label"
                        @Select="onPrioritySelect"
                        @remove="onPriorityRemove"
                      />
                      <v-errors :errors="errorFor('priority')"></v-errors>
                  </div>
                </div>
              </div>
              <div :class="['form_row', {'has_error': errorFor('request_from')}]">
                <label class="required">Request From</label>
                <select class="form_global" v-model="ticket.request_from">
                  <option value="">Select Request From</option>
                  <option value="phone">Phone</option>  
                  <option value="website">Website</option>
                  <option value="email">Email</option>  
                  <option value="chat">Chat</option>  
                  <option value="other">Other</option> 
                </select> 
                <v-errors :errors="errorFor('request_from')"></v-errors>
              </div>
              <div :class="['form_row', {'has_error': errorFor('subject')}]">
                <label class="required">Subject</label>
                <div class="form_inline">
                  <input type="text" class="form_global" v-model="ticket.subject">
                  <v-errors :errors="errorFor('subject')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', {'has_error': errorFor('description')}]">
                <label class="required">Description</label>
                <div class="form_inline">
                    <text-editor v-model:text="ticket['description']" :id="'description'"></text-editor>
                    <v-errors :errors="errorFor('description')"></v-errors>
                </div>
              </div>
            </div>
            <div class="col_6 pl_20">
              <div :class="['form_row', {'has_error': errorFor('contact_id')}]">
                <label class="required">Contact Email</label>
                  <Multiselect
                    v-model="selectedContact"
                    :options="contacts"
                    :multiple="false"
                    :close-on-select="true"
                    placeholder="Select a contact"
                    label="name"
                    :optionHeight="20"
                    track-by="id"
                    :custom-label="nameWithEmail"
                    @Select="onContactSelect"
                    @remove="onContactRemove"
                  />
                  <v-errors :errors="errorFor('contact_id')"></v-errors>
              </div>
              <div :class="['form_row', {'has_error': errorFor('customer_name')}]">
                <label>Contact name</label>
                <div class="form_inline">
                  <input type="text" class="form_global" v-model="ticket.customer_name">
                  <v-errors :errors="errorFor('customer_name')"></v-errors>
                </div>
              </div>
              <div :class="['form_row', {'has_error': errorFor('customer_phone')}]">
                <label>Contact phone</label>
                <div class="form_inline">
                  <input type="text" class="form_global" v-model="ticket.customer_phone">
                  <v-errors :errors="errorFor('customer_phone')"></v-errors>
                </div>
              </div>
              <div v-if="!selectedContact?.company_id" :class="['form_row', {'has_error': errorFor('new_company_id')}]">
                <label>Company</label>
                <div class="form_inline">
                  <Multiselect
                      v-model="selectedCompany"
                      :options="companies"
                      :multiple="false"
                      :close-on-select="true"
                      placeholder="Select a company"
                      label="company_name"
                      :optionHeight="20"
                      track-by="id"
                  />
                  <v-errors :errors="errorFor('new_company_id')"></v-errors>
                </div>
              </div>
              <div v-else :class="['form_row']">
                <label>Company</label>
                <div class="form_inline">
                  <input type="text" :value="selectedContact?.company?.company_name" class="form_global" disabled/>
                </div>
              </div>
              <div :class="['form_row', {'has_error': errorFor('cc_contact_id')}]">
                <label>CC Email</label>
                  <Multiselect
                    v-model="selectedCcContact"
                    :options="contacts"
                    :multiple="false"
                    :close-on-select="true"
                    placeholder="Select a contact"
                    label="name"
                    :optionHeight="20"
                    track-by="id"
                    :custom-label="nameWithEmail"
                    @Select="onCcContactSelect"
                    @remove="onCcContactRemove"
                  />
                  <v-errors :errors="errorFor('cc_contact_id')"></v-errors>
              </div>
              <div class="custom_tab_content_inner" :class="[{'has_error': errorFor('attachments')}]">
                <div class="product_list_wrap">
                  <h3>Email attachments</h3>
                  <div class="upload_btn dropzone-clickable mt_5 mb_10">
                      <button type="button" class="btn btn_black width_150p">Upload files</button>
                  </div>
                  <div class="product_list">
                      <draggable
                          :list="ticket.attachments"
                          item-key="image"
                          tag="ul"
                          ghost-class="ghost"
                          @end="imageSorted"
                      >
                          <template #item="{ element, index }">
                              <li>
                                  <div class="inner">
                                      <div class="img">
                                          <template v-if="['gif', 'png', 'jpg', 'jpeg', 'JPG'].includes(element.file_extension)">
                                              <div class="cross_ic" @click="removeImage(element, index)"><i class="fas fa-times"></i></div>
                                              <img :src="element.file_path">
                                          </template>
                                          <template v-if="['pdf'].includes(element.file_extension)">
                                              <div class="cross_ic" @click="removeImage(element, index)"><i class="fas fa-times"></i></div>
                                              <embed :src="element.file_path">
                                          </template>
                                          <template v-if="['xls','xlsx','xlm','xla','xlc','xlt','xlw','csv'].includes(element.file_extension)">
                                              <div class="cross_ic" @click="removeImage(element, index)"><i class="fas fa-times"></i></div>
                                              <i class="fas fa-file-excel fa-10x"></i>
                                          </template>
                                          <template v-if="['docx'].includes(element.file_extension)">
                                              <div class="cross_ic" @click="removeImage(element, index)"><i class="fas fa-times"></i></div>
                                              <i class="fas fa-file-word fa-10x"></i>
                                          </template>
                                          <template v-if="['zip'].includes(element.file_extension)">
                                              <div class="cross_ic" @click="removeImage(element, index)"><i class="fas fa-times"></i></div>
                                              <i class="fas fa-file-archive fa-10x"></i>
                                          </template>
                                          <!-- <template v-if="allErrors && allErrors['attachments.'+index]">
                                              pgh
                                              <small v-for="(error, errorIndex) in allErrors['attachments.'+index]" :key="'error_' + index + '_attachments_'+errorIndex">{{error}}</small>
                                          </template> -->
                                      </div>
                                  </div>
                              </li>
                          </template>
                      </draggable>
                  </div>
                  <div class="dropzone-previews"></div>
                  <div class="dropzone_wrap">
                      <div class="create_images_drag dropzone-clickable dropzone-container">
                          <div class="images">
                              <span>Drag and drop images from your computer.</span>
                          </div>
                      </div>
                  </div>
                </div>
            </div>
              <div class="form_row">
                <label></label>
                <div class="form_inline ">
                    <button class="btn btn_primary" :disabled="lyLoading" @click.prevent="update" v-if="$route.params.id">Update</button>
                    <button class="btn btn_primary" :disabled="lyLoading" @click.prevent="submit" v-else>Save</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
    import Dropzone from "dropzone";
    // import '@/assets/plugins/dropzone/scss/dropzone.scss';
    import LoaderMaskComponent from "@/components/LoaderMaskComponent.vue";
    import TextEditor from "@/components/shared/TextEditor";
    import Multiselect from 'vue-multiselect';
    import {mapGetters} from "vuex";
    // import vueDropzone from '@/components/dropzone';
    import draggable from 'vuedraggable'

    export default {
        name: 'ticket-form',
        components: {LoaderMaskComponent, TextEditor, Multiselect, draggable},
        data(){
            return {
              lyLoading: false,
              statuses:[
                {
                  label:'open',
                  name: 'Open'
                },
                {
                  label:'pending',
                  name: 'Pending'
                },
                {
                  label:'resolved',
                  name: 'Resolved'
                },
                {
                  label:'closed',
                  name: 'Closed'
                },
                
              ],
              priorities:[
                {
                  label:'low',
                  name: 'Low'
                },
                {
                  label:'medium',
                  name: 'Medium'
                },
                {
                  label:'high',
                  name: 'High'
                },
                {
                  label:'urgent',
                  name: 'Urgent'
                },
                
              ],
              selectedGroup: null,
              selectedRequestType: null,
              selectedUser: null,
              selectedStatus: null,
              selectedPriority: null,
              selectedContact: null,
              selectedCcContact: null,
              ticket: {
                group_id: '',
                user_id: '',
                status: '',
                priority: '',
                company_id: '',
                contact_id: '',
                customer_email: '',
                customer_name: '',
                customer_phone: '',
                cc_contact_id: '',
                cc_email: '',
                request_from: '',
                subject: '',
                description: '',
                attachments:[]
              },
              groups:[],
              requestTypes:[],
              users:[],
              contacts:[],
              dropzoneInstance: null,
              companies: [],
              selectedCompany: null,
            }
        },
        computed: {
            ...mapGetters({
                user: 'auth/getUser',
            })
        },
        mounted(){
          this.initializeDropzone();
        },
        created() {
            this.getGroups()
            this.getRequestTypes()
            this.getContacts()
            this.getCompanies()
        },
      updated() {
          this.initializeDropzone()
      },
      methods: {
          initializeDropzone(){
            if (this.dropzoneInstance) {
              this.dropzoneInstance.destroy();
              this.dropzoneInstance = null;
            }
            let that = this;
            const user = JSON.parse(localStorage.getItem('admin'))|| null
            // for image.
            that.$nextTick(() => {
              that.dropzoneInstance = new Dropzone(".dropzone-container", {
                clickable: '.dropzone-clickable',
                disablePreviews: true, // will not show preview
                createImageThumbnails: true,
                addRemoveLinks: true,
                previewsContainer: '.dropzone-previews',
                maxFiles: 2000,
                headers: {
                  'Authorization': `Bearer ${user.token}`
                },
                url: `${process.env.VUE_APP_API_BASE_URL}/temporary-image-upload`,
                success: function (file, response) {
                  let image = {
                    id: '',
                    sort: that.ticket.attachments.length + 1,
                    draft: response.draft,
                    file_extension: response.file_extension,
                    file_path: response.file_path,
                    original_file_name: response.original_file_name,
                    original_size: response.original_size,
                  }
                  that.ticket.attachments.push(image)
                  // since no preview there is nothing to remove
                  // this.removeFile(file); // This line removes the preview
                },
                error: function (file, response) {
                  let errors = that.errors ? that.errors : {};
                  errors.attachments = (errors && errors.attachments) ? errors.attachments : [];
                  errors.attachments = response.errors.file
                  that.errors = errors;
                  // this.removeFile(file);
                },
                removedfile: function () {
                  let errors = that.errors ? that.errors : {};
                  errors.attachments = null;
                  that.errors = errors;
                  // since no preview there is nothing to remove
                  // file.previewElement.remove();
                }
              });
            })
          },
          nameWithEmail(data){
            return `${data.name} — [ ${data.email} ]`;
          },
          getGroups() {
            this.axios.get('/active-groups-for-relation').then(({data}) => {
              this.groups = data.data
            })
          },
          getRequestTypes() {
            this.axios.get('/active-support-request-types').then(({data}) => {
              this.requestTypes = data.data
            })
          },
          getContacts() {
            this.axios.get('/active-contacts-for-relation').then(({data}) => {
              this.contacts = data.data
            })
          },
          onGroupSelect(selected){
            this.ticket.group_id = selected.id
            this.users = selected.users
            this.selectedUser = null
            this.ticket.user_id = ''
          },
          onRequestTypeSelect(selected){
            this.ticket.support_request_type_id = selected.id
          },
          onRequestTypeRemove(){
            this.selectedRequestType = null
            this.ticket.support_request_type_id = ''
          },
          onGroupRemove(){
            this.selectedGroup = null
            this.ticket.group_id = ''
            this.selectedUser = null
            this.ticket.user_id = ''
          },
          onStatusSelect(selected){
            this.ticket.status = selected.label
          },
          onStatusRemove(){
            this.ticket.status = ''
          },
          onPrioritySelect(selected){
            this.ticket.priority = selected.label
          },
          onPriorityRemove(){
            this.ticket.priority = ''
          },
          onUserSelect(selected){
            this.ticket.user_id = selected.id
          },
          onUserRemove(){
            this.selectedUser = null
            this.ticket.user_id = ''
          },
          onContactSelect(selected){
            this.ticket.contact_id = selected.id
            this.ticket.company_id = selected.company_id
            this.ticket.customer_email = selected.email
            this.ticket.customer_name = selected.name
            this.ticket.customer_phone = selected.phone
            this.resetSelectedCompany()
          },
          onContactRemove(){
            this.selectedContact = null
            this.ticket.contact_id = ''
            this.ticket.company_id = ''
            this.ticket.customer_email = ''
            this.ticket.customer_name = ''
            this.ticket.customer_phone = ''
            this.resetSelectedCompany()
          },
          onCcContactSelect(selected){
            this.ticket.cc_contact_id = selected.id
            this.ticket.cc_email = selected.email
          },
          onCcContactRemove(){
            this.ticket.cc_contact_id = ''
            this.ticket.cc_email = ''
          },
          removeImage(element, index){
            if(!this.ticket) return;
            if(!this.ticket.attachments) return;
            if (!element.id) {
                let formData = new FormData()
                formData.append('draft', element.draft);
                  this.axios.post('/temporary-image-remove', formData).then(() => {
                });
            }
            this.ticket.attachments.splice(index, 1)
            this.imageSorted();
          },
          imageSorted() {
            let sort = 1;
            for (let index = 0; index < this.ticket.attachments.length; index++) {
                this.ticket.attachments[index].sort = sort++;
            }
          },
          submit() {
              this.allErrors = null;
              this.lyLoading = true;

              let formData = new FormData()

              Object.keys(this.ticket).forEach(key => {
                  formData.append(key, this.ticket[key] ? this.ticket[key] : '');
              })

              formData.append('user', JSON.stringify(this.user))
              formData.append('attachments', JSON.stringify(this.ticket.attachments))
              if (this.selectedCompany?.id) {
                formData.append('new_company_id', this.selectedCompany?.id)
              }

              this.axios.post('/tickets', formData)
              .then(() => {
                  this.resetForm();
                  this.showSuccessMsg("Ticket Created Successfully!");
                  this.$router.push({ name: 'tickets'})
              })
              .catch((err) => {
                  this.allErrors = err.response.data.errors
                  this.showFailMsg(err.response.data.message);
              })
              .finally(() => {
                  this.lyLoading = false;
              })

          },
          resetForm(){
              this.ticket = {
                group_id: '',
                user_id: '',
                status: '',
                priority: '',
                company_id: '',
                contact_id: '',
                customer_email: '',
                customer_name: '',
                customer_phone: '',
                cc_contact_id: '',
                cc_email: '',
                request_from: '',
                subject: '',
                description: '',
                attachments:[]
              }
          },
        getCompanies() {
          this.axios.get('/active-companies-for-relation').then(({data}) => {
            this.companies = data.data
          })
        },
        resetSelectedCompany(){
            this.selectedCompany = null
        }
      }
    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.css"></style>
<style scoped lang="scss">
.create_item_tab button {
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.btn_back{
  position: relative;
  float: right;
  right: 0;
  top: 0;
}
.font_italic{
  position: relative;
  display: block;
  left: 120px;
  padding-top: 5px;
}
.multiselect{
  height: 50px;
}
.create_images_drag {
  position: relative;
  width: 100%;
  background: #efefef;
  min-height: 212px;
  margin-bottom: 10px;
}

.create_images_drag span {
  position: absolute;
  top: 50%;
  left: 50%;
  -webkit-transform: translate(-50%, -50%);
          transform: translate(-50%, -50%);
  font-size: 18px;
  color: #999;
}
.inner{
  border: 1px solid #E2E2E2 !important;
}
.product_list_wrap {
  .upload_btn {
      display: flex;
      align-items: center;
      margin-bottom: 15px;
      span {
          margin-left: 20px;
      }
  }
  .product_list {
      ul {
          display: flex;
          flex-wrap: wrap;
          margin-left: -5px;
          margin-right: -5px;
          li {
              width: 20%;
              padding-left: 5px;
              padding-right: 5px;
              padding-bottom: 10px;
              .inner {
                  .img {
                      position: relative;
                      overflow: hidden;
                      transition: all .3s;
                      img {
                          width: 100%;
                      }
                      .cross_ic {
                          position: absolute;
                          top: 20px;
                          right: 3px;
                          z-index: 2;
                          background: red;
                          border-radius: 50%;
                          width: 20px;
                          height: 20px;
                          display: flex;
                          align-items: center;
                          justify-content: center;
                          font-size: 15px;
                          opacity: 0;
                      }
                      &:hover {
                          transition: all .3s;
                          .cross_ic {
                              opacity: 1;
                              top: 3px;
                          }
                      }
                  }
              }
          }
      }
  }
}
</style>
